// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-dashboard-states-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.manage-dashboard-states-container{
    width: 45vw;
    max-height: 48vh;
    position: absolute;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.manage-dashboard-states-header{
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.manage-dashboard-states-header h3{
    margin: 0px;
    color: white;
    font-size: 22px;
    font-weight: 600;
}
.manage-dashboard-states-header p{
    margin: 0px;
    color: white;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.manage-dashboard-states-body{
    padding: 10px 32px;
    font-family: Roboto, sans-serif;
}
.manage-dashboard-states-tool-bar{
    display: flex;
    padding: 12px 0px;
    align-items: center;
    justify-content: space-between;
}
.manage-dashboard-states-tool-bar h4{
    margin: 0px;
    font-size: 20px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
}
.add-new-dashboard-state-button,
.search-dashboard-state-button{
    margin-left: 10px;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    background-color: transparent;
}
.add-new-dashboard-state-button{
    padding: 6px 8px;
}
.search-dashboard-state-button{
    padding: 6px 8px;
}
.add-new-dashboard-state-button:hover,
.search-dashboard-state-button:hover{
    background-color: rgb(245, 245, 245);
}
.add-new-dashboard-state-button img,
.search-dashboard-state-button img{
    height: 25px;
}
.manage-dashboard-states-search-bar{
    padding: 12px 5px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.manage-dashboard-states-search-bar img{
    height: 25px;
}
.manage-dashboard-states-search-bar input{
    width: 100%;
    padding: 5px;
    border: none;
    outline: none;
    margin: 0px 15px;
    font-size: 16px;
    border-bottom: 2px solid rgb(128, 128, 128);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.manage-dashboard-states-search-bar input:focus{
    border-bottom: 2px solid rgba(155, 30, 30, 0.952);
}
.manage-dashboard-states-search-bar p{
    margin: 0px;
    cursor: pointer;
}
.dashboard-states-table-container{
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    max-height: 24vh;
}
.dashboard-states-table{
    width: 100%;
    table-layout: fixed;
}
.dashboard-states-table th{
    padding: 12px 0px;
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    border-bottom: 1px solid rgb(224, 224, 224);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.dashboard-states-table td{
    text-align: left;
    font-size: 14px;
    padding: 6px 0px;
    border-bottom: 1px solid rgb(224, 224, 224);
}
.dashboard-states-table td:last-child{
    display: flex;
    justify-content: space-evenly;
    padding: 6px 10px;
    box-sizing: border-box;
}
.dashboard-states-table td button{
    cursor: pointer;
    border: none;
    border-radius: 80px;
    box-sizing: border-box;
    background-color: transparent;
}
.dashboard-states-table td img{
    height: 25px;
}
.manage-dashboard-states-footer{
    padding: 16px 32px;
    padding-bottom: 24px;
    text-align: right;
}
.manage-dashboard-states-footer button{
    border: none;
    font-weight: 600;
    margin-left: 12px;
    border-radius: 4px;
    padding: 8px 24px;
    padding-bottom: 10px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.manage-dashboard-states-footer .cancel-button{
    cursor: pointer;
    color: rgba(155, 30, 30, 0.952);
}
.manage-dashboard-states-footer .cancel-button:hover{
    background-color: rgb(226, 226, 226);
}
.manage-dashboard-states-footer .save-button.active{
    cursor: pointer;
    color: white;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    background-color: rgba(155, 30, 30, 0.952);
}
.manage-dashboard-states-footer .save-button.active:hover{
    background-color: rgba(187, 69, 69, 0.952);
}
.manage-dashboard-states-footer .save-button.inactive{
    cursor: default;
    color: rgb(160, 160, 160);
    background-color: rgb(240, 240, 240);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Dashboards/ManageDashboardStates.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,0CAA0C;IAC1C,sBAAsB;IACtB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,oCAAoC;AACxC;AACA;;IAEI,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,2CAA2C;IAC3C,4DAA4D;AAChE;AACA;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,2CAA2C;IAC3C,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,4DAA4D;AAChE;AACA;IACI,eAAe;IACf,+BAA+B;AACnC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,YAAY;IACZ,2CAA2C;IAC3C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,oCAAoC;AACxC","sourcesContent":[".manage-dashboard-states-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.manage-dashboard-states-container{\r\n    width: 45vw;\r\n    max-height: 48vh;\r\n    position: absolute;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.manage-dashboard-states-header{\r\n    margin: 0px;\r\n    padding: 10px 25px;\r\n    width: 100%;\r\n    border-radius: 5px 5px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.manage-dashboard-states-header h3{\r\n    margin: 0px;\r\n    color: white;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n}\r\n.manage-dashboard-states-header p{\r\n    margin: 0px;\r\n    color: white;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    font-weight: 400;\r\n}\r\n.manage-dashboard-states-body{\r\n    padding: 10px 32px;\r\n    font-family: Roboto, sans-serif;\r\n}\r\n.manage-dashboard-states-tool-bar{\r\n    display: flex;\r\n    padding: 12px 0px;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.manage-dashboard-states-tool-bar h4{\r\n    margin: 0px;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n    color: rgba(0, 0, 0, 0.87);\r\n}\r\n.add-new-dashboard-state-button,\r\n.search-dashboard-state-button{\r\n    margin-left: 10px;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    background-color: transparent;\r\n}\r\n.add-new-dashboard-state-button{\r\n    padding: 6px 8px;\r\n}\r\n.search-dashboard-state-button{\r\n    padding: 6px 8px;\r\n}\r\n.add-new-dashboard-state-button:hover,\r\n.search-dashboard-state-button:hover{\r\n    background-color: rgb(245, 245, 245);\r\n}\r\n.add-new-dashboard-state-button img,\r\n.search-dashboard-state-button img{\r\n    height: 25px;\r\n}\r\n.manage-dashboard-states-search-bar{\r\n    padding: 12px 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-evenly;\r\n}\r\n.manage-dashboard-states-search-bar img{\r\n    height: 25px;\r\n}\r\n.manage-dashboard-states-search-bar input{\r\n    width: 100%;\r\n    padding: 5px;\r\n    border: none;\r\n    outline: none;\r\n    margin: 0px 15px;\r\n    font-size: 16px;\r\n    border-bottom: 2px solid rgb(128, 128, 128);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.manage-dashboard-states-search-bar input:focus{\r\n    border-bottom: 2px solid rgba(155, 30, 30, 0.952);\r\n}\r\n.manage-dashboard-states-search-bar p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n}\r\n.dashboard-states-table-container{\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    width: 100%;\r\n    max-height: 24vh;\r\n}\r\n.dashboard-states-table{\r\n    width: 100%;\r\n    table-layout: fixed;\r\n}\r\n.dashboard-states-table th{\r\n    padding: 12px 0px;\r\n    text-align: left;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: rgba(0, 0, 0, 0.87);\r\n    border-bottom: 1px solid rgb(224, 224, 224);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.dashboard-states-table td{\r\n    text-align: left;\r\n    font-size: 14px;\r\n    padding: 6px 0px;\r\n    border-bottom: 1px solid rgb(224, 224, 224);\r\n}\r\n.dashboard-states-table td:last-child{\r\n    display: flex;\r\n    justify-content: space-evenly;\r\n    padding: 6px 10px;\r\n    box-sizing: border-box;\r\n}\r\n.dashboard-states-table td button{\r\n    cursor: pointer;\r\n    border: none;\r\n    border-radius: 80px;\r\n    box-sizing: border-box;\r\n    background-color: transparent;\r\n}\r\n.dashboard-states-table td img{\r\n    height: 25px;\r\n}\r\n.manage-dashboard-states-footer{\r\n    padding: 16px 32px;\r\n    padding-bottom: 24px;\r\n    text-align: right;\r\n}\r\n.manage-dashboard-states-footer button{\r\n    border: none;\r\n    font-weight: 600;\r\n    margin-left: 12px;\r\n    border-radius: 4px;\r\n    padding: 8px 24px;\r\n    padding-bottom: 10px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.manage-dashboard-states-footer .cancel-button{\r\n    cursor: pointer;\r\n    color: rgba(155, 30, 30, 0.952);\r\n}\r\n.manage-dashboard-states-footer .cancel-button:hover{\r\n    background-color: rgb(226, 226, 226);\r\n}\r\n.manage-dashboard-states-footer .save-button.active{\r\n    cursor: pointer;\r\n    color: white;\r\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.manage-dashboard-states-footer .save-button.active:hover{\r\n    background-color: rgba(187, 69, 69, 0.952);\r\n}\r\n.manage-dashboard-states-footer .save-button.inactive{\r\n    cursor: default;\r\n    color: rgb(160, 160, 160);\r\n    background-color: rgb(240, 240, 240);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
